import Config       from '../../common/model/Config';
import GlobalVar    from '../../common/model/GlobalVar';
import Provider     from '../../common/model/Provider';
import {template}   from './templateCtrl';

export const rendering = {
    init: () =>{
        rendering.createTemplateView();
    },
    createTemplateView: () => {
        
        var config = Config;
        var rsJson = { p:Provider, g:GlobalVar, c:Config}
        
        //main Template Load
        template.main_template();
        
        //<header> load
        template.header(config);

        //left side bar Load
        template.sidebar(config);
        
        //Step1 입력 Form Load
        template.form_bottom_button({signType:Provider.contentInfo.signType});
        template.form_inputInfo(rsJson);
        template.form_serviceSelect(config);
        
        //Step2 인증 대기화면 Load
        template.standby(rsJson);

        //개인정보 동의 Load
        if(!config.template.view_policy1.hidden){ template.popup_policy1(config.template.view_policy1.path) }
        if(!config.template.view_policy2.hidden){ template.popup_policy2(config.template.view_policy2.path) }
        if(!config.template.view_policy3.hidden){ template.popup_policy3(config.template.view_policy3.path) }
        if(!config.template.view_policy4.hidden){ template.popup_policy4(config.template.view_policy4.path) }
        
        //Alert Load
        template.popup_sign_origin();
        template.popup_naver_standby_step();
        template.popup_system_warring();
        template.popup_info_yn();
        template.popup_other_service();

        //Mobile View load
        template.mobile_agree(config);
        template.mobile_footer();
        template.mobile_select_service_toolbar();
    }
}